import React, { useEffect } from "react"
import Home from "./Home"
import About from "./About"
import Gutters from "./Gutters"
import GutterGuards from "./GutterGuards"
import CleaningAndRepairs from "./CleaningAndRepairs"
import Login from "./Login"
import Cart from "./Cart"
import Products from "./Products"
import CreateAccount from "./CreateAccount"
import NotFound from "./NotFound"
import SingleProductView from "./SingleProductView"
import { useSelector, useDispatch } from "react-redux"
import {
  loginWithToken,
  fetchGuestCart,
  fetchUserCart,
  fetchProducts,
  getWishlist,
} from "../store"
import { Link, Routes, Route } from "react-router-dom"
import Header from "./Header"
import Navbar from "./Navbar"
import Navbar2 from "./Navbar2"
import Account from "./Account"
import Landing from "./Landing"
import Contact from "./Contact"
import AdminPage from "./pages/AdminPage"
import AdminLeadsPage from "./pages/AdminLeadsPage"
import AdminQuotePage from "./pages/AdminQuotePage"
import AdminUserPage from "./pages/AdminUserPage"
import AdminProductPage from "./pages/AdminProductPage"
import AdminOrdersPage from "./pages/AdminOrdersPage"
import AdminReviewsPage from "./pages/AdminReviewsPage"
import { ToastProvider } from "./ui/ToastProvider"
import { useToast } from "../hooks/useToast"
import CheckoutPage from "./pages/CheckoutPage"
import Orders from "./pages/OrdersPage"
import Reviews from "./Reviews"
import OrderVerifyPage from "./pages/OrderVerifyPage"
import WishlistPage from "./pages/WishlistPage"
import "./styles/App.css"

const App = () => {
  const auth = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const { toasts } = useToast()
  useEffect(() => {
    dispatch(loginWithToken())
    dispatch(fetchProducts())
  }, [])

  useEffect(() => {
    if (auth.id) {
      dispatch(fetchUserCart())
      dispatch(getWishlist(auth.id))
    } else {
      dispatch(fetchGuestCart())
    }
  }, [auth.dispatch])
  return (
    <div className="app">
      <Header />
      <Navbar auth={auth} />
      <Navbar2 />
      <div className="app-container" id="mainBackground">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/account" element={<Account />} />
          <Route path="gutters" element={<Gutters />} />
          <Route path="gutterguards" element={<GutterGuards />} />
          <Route path="cleaningandrepairs" element={<CleaningAndRepairs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/account/wishlist" element={<WishlistPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/account/create" element={<CreateAccount />} />
          <Route path="/products" element={<Products />} />
          <Route path="/admin" element={<AdminPage />}>
            <Route path="/admin/users" element={<AdminUserPage />} />
            <Route path="/admin/leads" element={<AdminLeadsPage />} />
            <Route path="/admin/quote" element={<AdminQuotePage />} />
            <Route path="/admin/products" element={<AdminProductPage />} />
            <Route path="/admin/orders" element={<AdminOrdersPage />} />
            <Route path="/admin/reviews" element={<AdminReviewsPage />} />
          </Route>
          <Route path="/products/:id" element={<SingleProductView />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/verify" element={<OrderVerifyPage />} />
          <Route path="/orders/create" element={<CheckoutPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <ToastProvider toasts={toasts} />
    </div>
  )
}

export default App
